export default __webpack_public_path__ + "static/media/hunny-desktop-cover.874d2858.png";